import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useDashboardTFunction } from '@retail/dashboard/i18n';
import { DASHBOARD_PERIODS, DashboardPeriod } from './period';

interface Props {
  value: DashboardPeriod;
  onChange: (period: DashboardPeriod) => void;
  periods?: readonly DashboardPeriod[];
  size?: 'small' | 'medium';
}

export const PeriodSelect = ({
  value,
  onChange,
  periods = DASHBOARD_PERIODS,
  size = 'small',
}: Props) => {
  const t = useDashboardTFunction();

  return (
    <ToggleButtonGroup
      exclusive
      size={size}
      value={value}
      onChange={(_, next: DashboardPeriod | null) => next && onChange(next)}
      aria-label={t('dashboard.period.week')}
    >
      {periods.map((period) => (
        <ToggleButton
          key={period}
          value={period}
          sx={{ textTransform: 'none', whiteSpace: 'nowrap', py: 0.5 }}
        >
          {t(`dashboard.period.${period}`)}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
